import { render } from "./ExplanationPane.vue?vue&type=template&id=0a2ae736"
import script from "./ExplanationPane.vue?vue&type=script&lang=js"
export * from "./ExplanationPane.vue?vue&type=script&lang=js"

import "./ExplanationPane.vue?vue&type=style&index=0&id=0a2ae736&lang=scss"
script.render = render

export default script